if (!customElements.get('country-switcher-popup')) {
  const { Fancybox } = await import('@fancyapps/ui');

  class CountrySwitcherPopup extends HTMLElement {
    constructor() {
      super();

      let searchUrl = location.search;
      this.anchors = this.querySelectorAll('[data-href]');
      this.anchors.forEach((anchor) => {
        let currentUrl = anchor.dataset.href;
        let newUrl = currentUrl + searchUrl;
        anchor.dataset.href = newUrl;
      });

      this.target = this.querySelector('[data-country-switcher-popup-target]').innerHTML;
      this.triggers = document.querySelectorAll('[data-country-switcher-popup-trigger]');

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.openPopup.bind(this));
      });
    }

    openPopup() {
      new Fancybox(
        [
          {
            src: this.target,
            type: 'html',
            autoFocus: false,
            fullscreen: {
              autoStart: true,
            },
          },
        ],
        {
          mainClass: 'country-switcher-popup-wrapper',
        }
      );

      // Set up event listeners for country links after popup opens
      this.setupCountryLinks();
    }

    setupCountryLinks() {
      let d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 30);

      document.querySelectorAll('[data-country-iso]').forEach((countryLink) => {
        countryLink.addEventListener('click', (event) => {
          event.preventDefault();
          let isoCode = countryLink.dataset.countryIso;
          let url = countryLink.dataset.href;

          // Set cookie for user location
          document.cookie =
            'code-user-location-new' +
            '=' +
            isoCode +
            ';path=/;domain=.alpinestars.com;expires=' +
            d.toGMTString();

          // Navigate to the country URL
          if (url) {
            window.location.href = url;
          }
        });
      });
    }
  }

  window.CountrySwitcherPopup = CountrySwitcherPopup;

  customElements.define('country-switcher-popup', CountrySwitcherPopup);
}
